import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PendingTask } from '../../../services/dashboard.service';

/**
 * Tareas que requieren la intervención del propietario. Se generan a partir de
 * condiciones reales del negocio; si no hay ninguna, se comunica en positivo.
 */
@Component({
  selector: 'app-dashboard-tasks',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="tasks" aria-labelledby="tasks-title">
      <header>
        <h3 id="tasks-title">Tareas pendientes</h3>
        <span class="count" *ngIf="tasks.length">{{ tasks.length }}</span>
      </header>

      <ul *ngIf="tasks.length; else allDone">
        <li *ngFor="let task of tasks">
          <button type="button" [ngClass]="'tone-' + task.tone" (click)="run.emit(task.module)">
            <span class="icon" aria-hidden="true"><i class="bi" [ngClass]="task.icon"></i></span>
            <span class="body">
              <strong>{{ task.title }}</strong>
              <small>{{ task.detail }}</small>
            </span>
            <i class="bi bi-chevron-right arrow" aria-hidden="true"></i>
          </button>
        </li>
      </ul>

      <ng-template #allDone>
        <div class="done">
          <span class="done-icon" aria-hidden="true"><i class="bi bi-check2-circle"></i></span>
          <div>
            <strong>Todo al día.</strong>
            <small>No tienes tareas pendientes.</small>
          </div>
        </div>
      </ng-template>
    </section>
  `,
  styles: [`
    :host { display: block; height: 100%; }
    .tasks { box-sizing: border-box; height: 100%; padding: .9rem 1rem; border: 1px solid var(--ts-card-border, var(--ts-border)); border-radius: var(--ts-radius-lg); background: var(--ts-surface); box-shadow: var(--ts-card-shadow, var(--ts-shadow-sm)); }
    header { display: flex; align-items: center; gap: .5rem; margin-bottom: .7rem; }
    h3 { margin: 0; color: var(--ts-text); font-family: "Plus Jakarta Sans", Inter, sans-serif; font-size: .92rem; letter-spacing: -.02em; }
    .count { display: grid; place-items: center; min-width: 20px; height: 20px; padding: 0 .35rem; color: var(--ts-text-red-200-2); border-radius: 999px; background: var(--ts-bg-red-450-a13); font-size: .63rem; font-weight: 800; }
    ul { display: grid; gap: .45rem; margin: 0; padding: 0; list-style: none; }
    li button { display: flex; align-items: center; gap: .65rem; width: 100%; min-height: 52px; padding: .52rem .62rem; text-align: left; font: inherit; border: 1px solid var(--ts-border-faint-3); border-radius: 10px; background: linear-gradient(90deg, var(--ts-surface-soft), var(--ts-surface)); cursor: pointer; transition: transform var(--ts-transition), border-color var(--ts-transition), background var(--ts-transition); }
    li button:hover { transform: translateX(2px); border-color: var(--ts-border-blue-400-a40); background: var(--ts-surface-hover); }
    li button:focus-visible { outline: 2px solid var(--ts-border-blue-400-a28-2); outline-offset: 1px; }
    .icon { display: grid; place-items: center; width: 34px; height: 34px; flex: 0 0 34px; border-radius: 10px; font-size: .9rem; }
    .body { display: grid; gap: .08rem; min-width: 0; }
    .body strong { color: var(--ts-text); font-size: .73rem; }
    .body small { color: var(--ts-text-muted); font-size: .64rem; }
    .arrow { margin-left: auto; color: var(--ts-text-subtle); font-size: .75rem; }
    .tone-orange .icon { color: var(--ts-text-amber-350); background: var(--ts-bg-orange-450-a22); }
    .tone-violet .icon { color: var(--ts-text-indigo-200); background: var(--ts-bg-indigo-350-a15); }
    .tone-green .icon { color: var(--ts-text-green-350-2); background: var(--ts-bg-green-500-a22); }
    .tone-blue .icon { color: var(--ts-text-blue-300-4); background: var(--ts-bg-blue-400-a24); }
    .done { display: flex; align-items: center; gap: .65rem; padding: .7rem; border: 1px solid var(--ts-border-faint-3); border-radius: 10px; background: var(--ts-header-wash-2); }
    .done-icon { display: grid; place-items: center; width: 34px; height: 34px; flex: 0 0 34px; color: var(--ts-success); border-radius: 50%; background: var(--ts-success-soft-10); font-size: 1rem; }
    .done strong { display: block; color: var(--ts-text); font-size: .74rem; }
    .done small { color: var(--ts-text-muted); font-size: .65rem; }
  `],
})
export class DashboardTasksComponent {
  @Input() tasks: PendingTask[] = [];
  @Output() run = new EventEmitter<string>();
}
